import React from 'react';
import { ArrowCircleRightIcon as HeroArrowCircleRightIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ArrowCircleRightIconProps = Omit<IconProps, 'children'>;

export const ArrowCircleRightIcon: React.FC<ArrowCircleRightIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroArrowCircleRightIcon />
        </Icon>
    );
};
